import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import VoucherForm from '../components/voucher/VoucherForm';
import VoucherSuccess from '../components/voucher/VoucherSuccess';
import ApiClient from '../loopback/apiClient';
import { RootState } from '../redux/types';
import { setVoucherDetail, loggedOut } from '../redux/actions';

const RedeemVoucherView: React.FC<unknown> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginData = useSelector((state: RootState) => state.users.token);
  const locale = useSelector((state: RootState) => state.intl.locale);
  const voucherDetail = useSelector((state: RootState) => state.voucher.voucherDetail);
  const email = loginData?.email;
  const [error, setError] = useState<string | React.ReactNode>('');

  const voucherNewLoginHandler = useCallback(() => {
    if (loginData && loginData.id) {
      ApiClient.logout(true)
        .then(() => {
          dispatch(loggedOut());
          navigate('/login?redirect=voucherenroll');
        }).catch(() => undefined);
    } else {
      navigate('/login?redirect=voucherenroll');
    }
  }, [dispatch, loginData, navigate]);

  const voucherUserRegisterHandler = useCallback(() => {
    navigate('/register?origin=voucher');
  }, [navigate]);

  const voucherContinueLoginHandler = useCallback(() => {
    navigate('/voucherenroll');
  }, [navigate]);

  const submitCodeHandler = async (codePrefix?: string, codeInput?: string): Promise<void> => {
    if (!codePrefix || !codeInput || codePrefix?.length < 4 || codeInput?.length < 6) {
      return;
    }
    const voucherCode = codePrefix.concat('-').concat(codeInput);
    const voucherClaimDetail = await ApiClient.getVoucherDetail(voucherCode, locale);

    if (!voucherClaimDetail || !voucherClaimDetail.trial) {
      setError(<FormattedMessage id="voucher.invalidCode" />);
      return;
    }

    if (voucherClaimDetail.quipUserId) {
      setError(<FormattedMessage id="voucher.codeReedemed" />);
      return;
    }

    dispatch(setVoucherDetail(voucherClaimDetail));
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {
        voucherDetail !== undefined ? (
          <div style={{ margin: '0 auto' }}>
            <VoucherSuccess
              voucherDetail={voucherDetail}
              onNewLoginClick={voucherNewLoginHandler}
              onRegisterClick={voucherUserRegisterHandler}
              onContinueLoginClick={voucherContinueLoginHandler}
              email={email}
            />
          </div>
        ) : (
          <div style={{ margin: '0 auto' }}>
            <VoucherForm
              onSubmit={submitCodeHandler}
              errorMessage={error}
            />
          </div>
        )
      }
    </Container>

  );
};

export default RedeemVoucherView;
